@if (service) {
  <div class="cms-card">
    <div class="cms-card__section">
      <div class="cms-card__actions">
        <div class="cms-card__drag-handle" cdkDragHandle>
          <i class="pi pi-arrows-alt cms-card__drag-icon"></i>
        </div>
        <p-button icon="pi pi-times" [rounded]="true" [text]="true" severity="danger" (onClick)="onDeleteClick()" />
      </div>
      <span class="cms-card__field-label">Image</span>
      <div class="cms-card__image-row">
        <div class="cms-card__image-thumb-wrap">
          @if (currentImageSrc) {
            <img
              [src]="currentImageSrc"
              [alt]="editTitle"
              class="cms-card__image-thumb-img"
            />
          } @else {
            <div class="cms-card__image-placeholder">
              <i class="pi pi-image"></i>
            </div>
          }
        </div>
        <div class="cms-card__image-meta">
          @if (uploadedFileName) {
            <span class="cms-card__image-name">{{ uploadedFileName }}</span>
          } @else if (!currentImageSrc) {
            <span class="cms-card__image-name cms-card__image-name--placeholder">No image selected</span>
          }
          <span class="cms-card__image-size">{{ uploadedFileSize }}</span>
          <input
            #fileInput
            type="file"
            accept="image/*"
            class="cms-card__file-input-hidden"
            (change)="onNativeFileSelected($event)"
          />
          <p-button
            [label]="currentImageSrc ? 'Change Photo' : 'Upload Photo'"
            icon="pi pi-upload"
            severity="secondary"
            size="small"
            styleClass="cms-card__upload-btn"
            (onClick)="fileInput.click()"
          />
        </div>
      </div>
    </div>
    <div class="cms-card__section">
      <label class="cms-card__field-label" for="card-title">Title</label>
      <input
        pInputText
        id="card-title"
        [ngModel]="editTitle"
        (ngModelChange)="onTitleChange($event)"
        class="cms-card__input"
        [class.cms-card__input--invalid]="!editTitle.trim()"
      />
    </div>
    <div class="cms-card__section">
      <label class="cms-card__field-label" for="card-description">Description</label>
      <textarea
        pTextarea
        id="card-description"
        [ngModel]="editDescription"
        (ngModelChange)="onDescriptionChange($event)"
        rows="4"
        class="cms-card__textarea"
        [class.cms-card__textarea--invalid]="!editDescription.trim()"
      ></textarea>
    </div>
    <div class="cms-card__section">
      <label class="cms-card__field-label">Labels</label>
      @if (singleLabel) {
        <p-select
          [options]="allLabelOptions"
          [ngModel]="singleLabelValue"
          (ngModelChange)="onSingleLabelChange($event)"
          optionLabel="label"
          optionValue="value"
          placeholder="Select a label"
          [showClear]="true"
          [styleClass]="'cms-card__multiselect' + (editLabels.length === 0 ? ' cms-card__multiselect--invalid' : '')"
          appendTo="body"
        />
      } @else {
        <p-multiSelect
          [options]="allLabelOptions"
          [ngModel]="editLabels"
          (ngModelChange)="onLabelsChange($event)"
          optionLabel="label"
          optionValue="value"
          placeholder="Select labels"
          [filter]="true"
          [maxSelectedLabels]="0"
          selectedItemsLabel="{0} labels selected"
          [styleClass]="'cms-card__multiselect' + (editLabels.length === 0 ? ' cms-card__multiselect--invalid' : '')"
          appendTo="body"
        />
      }
    </div>
  </div>
  <p-dialog
    [(visible)]="showDeleteDialog"
    [modal]="true"
    [closable]="true"
    [draggable]="false"
    [resizable]="false"
    styleClass="cms-card__delete-dialog"
    appendTo="body"
  >
    <ng-template pTemplate="header">
      <div class="cms-card__delete-dialog-header">
        <i class="pi pi-exclamation-triangle cms-card__delete-dialog-icon"></i>
        <span>Delete Service</span>
      </div>
    </ng-template>
    <p class="cms-card__delete-dialog-message">
      Are you sure you want to permanently delete service
      <strong>&ldquo;{{ editTitle || 'this card' }}&rdquo;</strong>?
    </p>
    <ng-template pTemplate="footer">
      <p-button
        label="No"
        severity="secondary"
        [outlined]="true"
        (onClick)="onCancelDelete()"
      />
      <p-button
        label="Yes, delete"
        severity="danger"
        icon="pi pi-trash"
        (onClick)="onConfirmDelete()"
      />
    </ng-template>
  </p-dialog>
}
